import { z } from 'zod';

import { uuidValidator } from '../../validators';

export const TagResponseSchema = z.object({
  id: uuidValidator,
  name: z.string(),
  userId: uuidValidator,
});

export type ITagResponseDto = z.infer<typeof TagResponseSchema>;
